import { bulkPincodeCheckActions } from './bulkPincodeCheckActionCreator';

const initialState = {
  isFetching: false,
  clientList: [],
  bulkPincodeCheckRes: null,
  errorBulkPincodeCheck: null,
  serviceType: null
};

const bulkPincodeCheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case bulkPincodeCheckActions.SET_CLIENT_LIST:
      const dropdown = [];
      if (action.payload.length > 0) {
        action.payload.map(option =>
          dropdown.push({ key: option.billingName, value: option.clientCode })
        );
      }
      return { ...state, clientList: dropdown };

    case bulkPincodeCheckActions.SET_SERVICE_TYPE:
      return { ...state, serviceCategoryToServiceTypeMap: action.payload };

    case bulkPincodeCheckActions.SET_IS_FETCHING_CLIENT_LIST:
      return { ...state, isFetching: action.payload };

    case bulkPincodeCheckActions.SET_IS_FETCHING_SERVICE_TYPE:
      return { ...state, isFetching: action.payload };

    case bulkPincodeCheckActions.RESET_CLIENT_LIST_AND_FETCHING:
      return { ...state, isFetching: false, clientList: [] };

    case bulkPincodeCheckActions.RESET_SERVICE_TYPE_AND_FETCHING:
      return { ...state, isFetching: false, serviceType: null };

    case bulkPincodeCheckActions.BULK_PINCODE_CHECK_CALL:
      return {
        ...state,
        bulkPincodeCheckRes: action.payload.bulkPincodeCheckRes,
        errorBulkPincodeCheck: action.payload.errorBulkPincodeCheck
      };

    default: {
      return state;
    }
  }
};

export default bulkPincodeCheckReducer;
